import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter, Redirect } from 'react-router-dom';
import config from 'config/api';
import i18n from 'helpers/i18n';
import { withStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Paper from '@material-ui/core/Paper';
import ScrollToTopOnMount from 'components/UI/ScrollToTopOnMount';
import Header from 'components/Header/Header';
import Banner from 'components/Banner/Banner';
import AccountSettingsForm from './AccountSettingsForm';
import Typography from '@material-ui/core/Typography';
import Template from 'components/Template/Template';
import { isLoggedIn, getCurrentUserRole } from 'ducks/authentication';
import { fetchData, getDataHome } from 'ducks/asyncFetcher';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Fade from '@material-ui/core/Fade';
import Footer from '../Footer';
const AF_KEY = 'home';
const styles = (theme) => {
  return {
    root: {
      minHeight: '100%',
      // display: "flex",
      // flexDirection: "column",
      // "& > *": {
      //   flex: 1,
      // },
      color: theme.palette.secondary.main,
    },
    paper: {
      padding: theme.spacing(4),
    },
  };
};
class Account extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // tabSelected: 0
    };
    this._onSubscriptionComplete = this._onSubscriptionComplete.bind(this);
    this._onClose = this._onClose.bind(this);
  }
  componentDidMount() {
    this.props.onMount();
  }
  _onSubscriptionComplete() {
    this.props.onMount();
  }
  _onClose() {
    const { history } = this.props;
    history.push('/');
  }
  render() {
    const { onPanelToggle, classes, userRole, isLoggedIn, $$data } = this.props;
    if (!isLoggedIn) {
      return (
        <Redirect
          to={{
            pathname: '/',
            state: { from: this.props.location },
          }}
        />
      );
    }
    return (
      <Template userRole={userRole} page="login" title={i18n.get('accountFormTitle', { pretty: true })}>
        <Box className={classes.root}>
          <AccountSettingsForm onFormCancel={this._onClose} />
        </Box>
      </Template>
    );
  }
}

function mapStateToProps(state) {
  const props = {
    $$data: getDataHome(state),
    isLoggedIn: isLoggedIn(state),
    userRole: getCurrentUserRole(state),
  };
  return props;
}

function mapDispatchToProps(dispatch) {
  return {
    onMount: () => {
      dispatch(
        fetchData({
          key: AF_KEY,
          fetchUrl: config.home,
        }),
      );
    },
  };
}
export default withStyles(styles)(withRouter(connect(mapStateToProps, mapDispatchToProps)(Account)));



// WEBPACK FOOTER //
// ./src/components/Account/Account.jsx